import { DoorNavigationState } from '@models/doors';

export function getNavigatedDoorNo(state: unknown): string {
  const doorNo = (state as DoorNavigationState | null)?.doorNo;
  return typeof doorNo === 'string' ? doorNo : '';
}
